import axios from 'axios';
import { LOGIN_ERROR, LOGIN_SUCCESS } from './types';

const { localStorage } = window;

/**
 * Method that handles the Google Oauth Response and then
 * sends it to our Auth Service to valitate it and generate
 * the Auth Token, save, {token, picture, name, refresh_token} to localStorage
 * @param {Object} googleResponse
 */
export const loginAction = (googleResponse) => async (dispatch) => {
  try {
    const resp = await axios.post(
      `${process.env.REACT_APP_AUTH_SERVICE}/auth/google`,
      googleResponse,
    );
    if (resp.status === 200 && resp.data.token) {
      const {
        // eslint-disable-next-line camelcase
        token, user_id, picture, name, refresh_token,
      } = resp.data;
      const userStorage = [];
      userStorage.push(picture, name, user_id);
      localStorage.setItem('user', userStorage);
      localStorage.setItem('token', token);
      localStorage.setItem('isLogged', 'true');
      localStorage.setItem('refresh_token', refresh_token);
      dispatch({
        type: LOGIN_SUCCESS,
        payload: {
          token,
          user_id,
          picture,
          name,
        },
      });
    } else {
      dispatch({
        type: LOGIN_ERROR,
      });
    }
  } catch (err) {
    dispatch({
      type: LOGIN_ERROR,
    });
  }
};

/**
 * Method that handles/set a problem with the Login
 */
export const loginErrorAction = () => (dispatch) => {
  dispatch({
    type: LOGIN_ERROR,
  });
};
